// import React, { useEffect, useState } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import CircularProgress from "@mui/material/CircularProgress";
// import axios from "axios";
// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DataTable from "examples/Tables/DataTable";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogTitle from "@mui/material/DialogTitle";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import dayjs from 'dayjs';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import DownloadIcon from "@mui/icons-material/Download";
// import { FormControl, InputLabel, Select, MenuItem, Snackbar, Typography } from "@mui/material";
// import Tooltip from "@mui/material/Tooltip";

// function UserList() {
//   const [columns, setColumns] = useState([]);
//   const [rows, setRows] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [deleteBox, setdeleteBox] = useState(false);
//   const [deleteuserId, setdeleteuserId] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   // Separate filter states
//   const [createdByFilter, setCreatedByFilter] = useState("");
//   const [updatedByFilter, setUpdatedByFilter] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [lastLoginDate, setLastLoginDate] = useState("");

//   const [creatorNames, setCreatorNames] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [modalData, setModalData] = useState({ email: "", password: "", portal: "" });

//   const [formData, setFormData] = useState({
//     email: "",
//     name: "",
//     mobileNumber: "",
//     userRole: "",
//     margin: "",
//     password: "",
//     updated_at: '',
//     updated_by: '',
//     createdByName: "",
//     updatedByName: "",
//   });

//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [SnackbarMsg, setSnackbarMsg] = useState("");

//   useEffect(() => {
//     const BUSINESS_TEAM_check = localStorage.getItem("userRole");
//     if (BUSINESS_TEAM_check === 'BUSINESS_TEAM') {
//       fetchUsersBusiness();
//     }
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const sessionToken = localStorage.getItem("sessionToken");

//       if (!sessionToken) {
//         console.error("Session token not found. Please log in again.");
//         return;
//       }

//       const response = await axios.get("https://api.exampladmedia.com/auth/getAllUsers", {
//         headers: {
//           Authorization: sessionToken,
//         },
//       });

//       const currentUserRole = localStorage.getItem("userRole");

//       const userColumns = [
//         { Header: "Sr. No.", accessor: "srNo", align: "center" },
//         { Header: " Client Email", accessor: "email", align: "center" },
//         { Header: "Client Name", accessor: "name", align: "center" },
//         { Header: "Margin", accessor: "margin", align: "center" },
//         { Header: "Created By", accessor: "createdByName", align: "center" },
//         { Header: "Created At", accessor: "created_at", align: "center" },
//         { Header: "Updated By", accessor: "updated_by", align: "center" },
//         { Header: "Updated At", accessor: "updated_at", align: "center" },
//         { Header: "Last Login ", accessor: "lastLogin", align: "center" },
//         {
//           Header: "User Role",
//           accessor: (row) => (row.userRole === "ADMIN" ? "OPERATIONS" : row.userRole),
//           align: "center",
//         },
//         {
//           Header: "Actions",
//           accessor: "actions",
//           align: "center",
//         },
//       ];

//       const userRows = response.data
//         .filter((user) => user.userRole !== "SUPER_ADMIN")
//         .map((user, index) => ({
//           srNo: index + 1,
//           email: user.email,
//           name: user.name,
//           margin: user.margin || "-",
//           created_by: user.created_by || "-",
//           created_at: user.created_at ? dayjs(user.created_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           createdByName: user.createdByName,
//           updated_by: user.updated_by || "-",
//           updated_at: user.updated_at ? dayjs(user.updated_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           updatedByName: user.updatedByName,
//           lastLogin: user.lastLogin ? dayjs(user.lastLogin).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           userRole: user.userRole,
//           actions: (
//             <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
//               <EditIcon
//                 style={{
//                   color: "green",
//                   cursor: "pointer",
//                   display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
//                 }}
//                 onClick={() => handleEdit(user)}
//               />
//               <DeleteIcon
//                 style={{
//                   color: "red",
//                   cursor: "pointer",
//                   display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
//                 }}
//                 onClick={() => handleConfirmDelete(user.userId)}
//               />
//             </div>
//           ),
//         }));

//       setColumns(userColumns);
//       setRows(userRows);

//       const allNames = [
//         ...new Set([
//           ...response.data.map((user) => user.createdByName).filter(Boolean),
//           ...response.data.map((user) => user.updatedByName).filter(Boolean),
//         ]),
//       ];
//       setCreatorNames(allNames);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUsersBusiness = async () => {
//     setLoading(true);
//     try {
//       const sessionToken = localStorage.getItem("sessionToken");
//       const ueserId = localStorage.getItem("ueserId");

//       if (!sessionToken) {
//         console.error("Session token not found. Please log in again.");
//         return;
//       }

//       const response = await axios.get(`https://api.exampladmedia.com/auth/getUsers/${ueserId}`, {
//         headers: {
//           Authorization: sessionToken,
//         },
//       });

//       const currentUserRole = localStorage.getItem("userRole");

//       const userColumns = [
//         { Header: "Sr. No.", accessor: "srNo", align: "center" },
//         { Header: "Email", accessor: "email", align: "center" },
//         { Header: "Name", accessor: "name", align: "center" },
//         { Header: "Margin", accessor: "margin", align: "center" },
//         // { Header: "Created By", accessor: "created_by", align: "center" },
//         ...(currentUserRole === "SUPER_ADMIN"
//           ? [
//             { Header: "Created By", accessor: "createdByName", align: "center" },
//           ]
//           : []),
//         { Header: "Created At", accessor: "created_at", align: "center" },
//         { Header: "Created By Name", accessor: "createdByName", align: "center" },
//         // { Header: "Updated By", accessor: "updated_by", align: "center" },
//         ...(currentUserRole === "SUPER_ADMIN"
//           ? [
//             { Header: "Updated By", accessor: "updated_by", align: "center" },
//           ]
//           : []),
//         { Header: "Updated At", accessor: "updated_at", align: "center" },
//         { Header: "Updated By Name", accessor: "updatedByName", align: "center" },
//         { Header: "Last Login ", accessor: "lastLogin", align: "center" },
//         { Header: "User Role", accessor: "userRole", align: "center" },
//         {
//           Header: "Actions",
//           accessor: "actions",
//           align: "center",
//         },
//       ];

//       const userRows = response.data
//         .filter((user) => user.userRole !== "SUPER_ADMIN")
//         .map((user, index) => ({
//           srNo: index + 1,
//           email: user.email,
//           name: user.name,
//           margin: user.margin || "-",
//           created_by: user.created_by || "-",
//           created_at: user.created_at ? dayjs(user.created_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           createdByName: user.createdByName,
//           updated_by: user.updated_by || "-",
//           updated_at: user.updated_at ? dayjs(user.updated_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           updatedByName: user.updatedByName,
//           lastLogin: user.lastLogin ? dayjs(user.lastLogin).format("DD-MMM-YYYY HH:mm:ss") : "-",
//           userRole: user.userRole,
//           actions: (
//             <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
//               <EditIcon
//                 style={{
//                   color: "green",
//                   cursor: "pointer",
//                   display: currentUserRole === "SUPER_ADMIN" || currentUserRole === "BUSINESS_TEAM" ? "inline-block" : "none",
//                 }}
//                 onClick={() => handleEdit(user)}
//               />
//               <DeleteIcon
//                 style={{
//                   color: "red",
//                   cursor: "pointer",
//                   display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
//                 }}
//                 onClick={() => handleConfirmDelete(user.userId)}
//               />
//             </div>
//           ),
//         }));

//       setColumns(userColumns);
//       setRows(userRows);

//       const allNames = [
//         ...new Set([
//           ...response.data.map((user) => user.createdByName).filter(Boolean),
//           ...response.data.map((user) => user.updatedByName).filter(Boolean),
//         ]),
//       ];
//       setCreatorNames(allNames);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setFormData({
//       email: user.email,
//       margin: user.margin,
//       userRole: user.userRole,
//       password: user.password,
//       updated_at: new Date().toISOString(),
//       updatedByName: localStorage.getItem("name"),
//       updated_by: localStorage.getItem("userRole"),
//     });
//     setOpen(true);
//   };

//   const handleConfirmDelete = (userId) => {
//     setdeleteuserId(userId);
//     setdeleteBox(true);
//   };

//   const handleDelete = async () => {
//     try {
//       const sessionToken = localStorage.getItem("sessionToken");
//       if (!sessionToken) {
//         console.error("Session token not found. Please log in again.");
//         return;
//       }

//       const response = await axios.delete(`https://api.exampladmedia.com/auth/delete/${deleteuserId}`, {
//         headers: {
//           Authorization: sessionToken,
//         },
//       });

//       if (response.status === 200) {
//         setSnackbarMsg(response.data.message);
//         setOpenSnackbar(true);
//         setTimeout(() => setOpenSnackbar(false), 2000);
//         setdeleteBox(false);
//         fetchUsers();
//       }
//     } catch (error) {
//       if (error.response) {
//         setSnackbarMsg(error.response.data.message || "An error occurred.");
//       } else {
//         setSnackbarMsg("An error occurred. Please try again.");
//       }
//       setOpenSnackbar(true);
//       setTimeout(() => setOpenSnackbar(false), 2000);
//     }
//   };

//   const handleSave = async () => {
//     try {
//       const sessionToken = localStorage.getItem("sessionToken");
//       if (!sessionToken) {
//         console.error("Session token not found. Please log in again.");
//         return;
//       }

//       const response = await axios.put(
//         `https://api.exampladmedia.com/auth/edit/${selectedUser.userId}`,
//         { ...formData },
//         { headers: { Authorization: sessionToken } }
//       );

//       const portalLink = "https://pricing.exampladmedia.com";
//       const clipboardText = `Email: ${formData.email}\nPassword: ${formData.password}\nPortal: ${portalLink}`;

//       if (response.status === 200) {
//         setModalData({
//           email: formData.email,
//           password: formData.password,
//           portal: portalLink,
//         });
//         setOpenModal(true);

//         try {
//           await navigator.clipboard.writeText(clipboardText);
//         } catch {
//           const textarea = document.createElement("textarea");
//           textarea.value = clipboardText;
//           document.body.appendChild(textarea);
//           textarea.select();
//           document.execCommand("copy");
//           document.body.removeChild(textarea);
//         }

//         setSnackbarMsg(response.data.message || "User updated and details copied!");
//         setOpenSnackbar(true);
//         setTimeout(() => setOpenSnackbar(false), 2000);
//         setOpen(false);
//         fetchUsers();
//       }
//     } catch (error) {
//       setSnackbarMsg(error.response?.data?.message || "An error occurred.");
//       setOpenSnackbar(true);
//       setTimeout(() => setOpenSnackbar(false), 2000);
//     }
//   };

//   const handleDownloadExcel = () => {
//     const exportData = filteredRows.map((row) => {
//       const { actions, ...rest } = row;
//       return rest;
//     });

//     const ws = XLSX.utils.json_to_sheet(exportData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Users");
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), "UserList.xlsx");
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleDeleteCancel = () => {
//     setdeleteBox(false);
//   };

//   const currentUserRole = localStorage.getItem("userRole");

//   const filteredRows = rows.filter((row) => {
//     const matchesSearch =
//       (row.name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
//       (row.email?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
//       (row.createdByName?.toLowerCase() || "").includes(searchTerm.toLowerCase());

//     const matchesCreatedBy =
//       createdByFilter === ""
//         ? true
//         : (row.createdByName?.toLowerCase() || "") === createdByFilter.toLowerCase();

//     const matchesUpdatedBy =
//       updatedByFilter === ""
//         ? true
//         : (row.updatedByName?.toLowerCase() || "") === updatedByFilter.toLowerCase();

//     const createdAt = row.created_at !== "-" ? dayjs(row.created_at) : null;
//     const matchesCreatedDate = fromDate
//       ? createdAt &&
//       createdAt.isAfter(dayjs(fromDate).startOf('day').subtract(1, 'ms')) &&
//       createdAt.isBefore(dayjs(fromDate).endOf('day').add(1, 'ms'))
//       : true;

//     const lastLogin = row.lastLogin !== "-" ? dayjs(row.lastLogin) : null;
//     const matchesLastLogin = lastLoginDate
//       ? lastLogin &&
//       lastLogin.isAfter(dayjs(lastLoginDate).startOf('day').subtract(1, 'ms')) &&
//       lastLogin.isBefore(dayjs(lastLoginDate).endOf('day').add(1, 'ms'))
//       : true;

//     return matchesSearch && matchesCreatedBy && matchesUpdatedBy && matchesCreatedDate && matchesLastLogin;
//   });

//   return (
//     <DashboardLayout>
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 flexWrap="wrap"
//                 gap={2}
//               >
//                 <h2 style={{ color: "white", margin: 0 }}>User List</h2>

//                 <MDBox display="flex" flexWrap="wrap" gap={2} alignItems="center">
//                   {currentUserRole === "SUPER_ADMIN" && (
//                     <>
//                       <MDBox sx={{ background: "white", borderRadius: "8px" }}>
//                         <FormControl
//                           variant="outlined"
//                           sx={{
//                             width: 220,
//                             backgroundColor: "white",
//                             borderRadius: "8px",
//                             boxShadow: 1,
//                             '& .MuiOutlinedInput-root': {
//                               height: 48,
//                               borderRadius: '8px',
//                               backgroundColor: 'white',
//                             },
//                             '& .MuiInputLabel-root': {
//                               fontSize: '14px',
//                               top: '-4px',
//                               backgroundColor: 'white',
//                               padding: '0 4px',
//                             },
//                             '& .MuiSelect-select': {
//                               padding: '14px',
//                               fontSize: '14px',
//                             },
//                           }}
//                         >
//                           <InputLabel>Created By</InputLabel>
//                           <Select
//                             value={createdByFilter}
//                             onChange={(e) => setCreatedByFilter(e.target.value)}
//                             label="Created By"
//                           >
//                             <MenuItem value="">All</MenuItem>
//                             {creatorNames.map((name) => (
//                               <MenuItem key={name} value={name}>{name}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </MDBox>

//                       <MDBox sx={{ background: "white", borderRadius: "8px" }}>
//                         <FormControl
//                           variant="outlined"
//                           sx={{
//                             width: 220,
//                             backgroundColor: "white",
//                             borderRadius: "8px",
//                             boxShadow: 1,
//                             '& .MuiOutlinedInput-root': {
//                               height: 48,
//                               borderRadius: '8px',
//                               backgroundColor: 'white',
//                             },
//                             '& .MuiInputLabel-root': {
//                               fontSize: '14px',
//                               top: '-4px',
//                               backgroundColor: 'white',
//                               padding: '0 4px',
//                             },
//                             '& .MuiSelect-select': {
//                               padding: '14px',
//                               fontSize: '14px',
//                             },
//                           }}
//                         >
//                           <InputLabel>Updated By</InputLabel>
//                           <Select
//                             value={updatedByFilter}
//                             onChange={(e) => setUpdatedByFilter(e.target.value)}
//                             label="Updated By"
//                           >
//                             <MenuItem value="">All</MenuItem>
//                             {creatorNames.map((name) => (
//                               <MenuItem key={name} value={name}>{name}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </MDBox>

//                       <TextField
//                         type="date"
//                         label="Created At"
//                         InputLabelProps={{
//                           shrink: true,
//                           sx: {
//                             color: "#000",     // black
//                             fontWeight: 700,   // bold
//                             fontSize: "13px",
//                           },
//                         }}
//                         value={fromDate}
//                         onChange={(e) => setFromDate(e.target.value)}
//                         sx={{
//                           backgroundColor: "#fff",
//                           borderRadius: "4px",
//                           width: "200px",

//                           "& .MuiInputLabel-root": {
//                             color: "#000",
//                             fontWeight: 700,
//                           },
//                           "& .MuiInputLabel-root.Mui-focused": {
//                             color: "#000",
//                             fontWeight: 700,
//                           },
//                         }}
//                       />


//                       <TextField
//                         type="date"
//                         label="Last Login"
//                         InputLabelProps={{
//                           shrink: true,
//                           sx: {
//                             color: "#000",     // black
//                             fontWeight: 700,   // bold
//                             fontSize: "13px",
//                           },
//                         }}
//                         value={lastLoginDate}
//                         onChange={(e) => setLastLoginDate(e.target.value)}
//                         sx={{
//                           backgroundColor: "#fff",
//                           borderRadius: "4px",
//                           width: "200px",

//                           "& .MuiInputLabel-root": {
//                             color: "#000",
//                             fontWeight: 700,
//                           },
//                           "& .MuiInputLabel-root.Mui-focused": {
//                             color: "#000",
//                             fontWeight: 700,
//                           },
//                         }}
//                       />

//                     </>
//                   )}

//                   <TextField
//                     variant="outlined"
//                     placeholder="Search by name, email..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     style={{ backgroundColor: "white", borderRadius: "4px", width: "400px" }}
//                   />

//                   {/* <Tooltip title="Download User List">
//                     <Button
//                       variant="outlined"
//                       onClick={handleDownloadExcel}
//                       style={{
//                         backgroundColor: "white",
//                         color: "grey",
//                         border: "1px solid #49a3f1",
//                         height: "48px",
//                       }}
//                     >
//                       <DownloadIcon />
//                     </Button>
//                   </Tooltip> */}
//                   {currentUserRole === "SUPER_ADMIN" && (
//                     <Tooltip title="Download User List">
//                       <Button
//                         variant="outlined"
//                         onClick={handleDownloadExcel}
//                         style={{
//                           backgroundColor: "white",
//                           color: "grey",
//                           border: "1px solid #49a3f1",
//                           height: "48px",
//                         }}
//                       >
//                         <DownloadIcon />
//                       </Button>
//                     </Tooltip>
//                   )}
//                 </MDBox>
//               </MDBox>

//               <MDBox pt={3}>
//                 {loading ? (
//                   <MDBox
//                     display="flex"
//                     justifyContent="center"
//                     alignItems="center"
//                     height="300px"
//                   >
//                     <CircularProgress color="info" />
//                   </MDBox>
//                 ) : (
//                   // <MDBox sx={{ maxHeight: "450px", overflowY: "auto" }}>
//                   <DataTable
//                     table={{ columns, rows: filteredRows }}
//                     isSorted={false}
//                     entriesPerPage={true}
//                     showTotalEntries={true}
//                     noEndBorder
//                   />
//                   // </MDBox>
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       <Dialog open={open} onClose={handleClose}>
//         <DialogTitle>Edit User</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="Email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             fullWidth
//             margin="normal"
//           />
//           {formData.userRole === "BUSINESS_TEAM" || formData.userRole === "ADMIN" || (
//             <TextField
//               label="Margin"
//               name="margin"
//               value={formData.margin}
//               onChange={handleChange}
//               fullWidth
//               margin="normal"
//             />
//           )}
//           <TextField
//             label="Password"
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             fullWidth
//             margin="normal"
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleSave} style={{ color: "green" }}>
//             Save
//           </Button>
//           <Button onClick={handleClose} style={{ color: "red" }}>
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteBox} onClose={handleDeleteCancel}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <p>Are you sure you want to delete this user?</p>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDelete} style={{ color: "green" }}>
//             Confirm
//           </Button>
//           <Button onClick={handleDeleteCancel} style={{ color: "red" }}>
//             Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={openModal} onClose={() => setOpenModal(false)}>
//         <DialogTitle>User Updated</DialogTitle>
//         <DialogContent dividers>
//           <Typography variant="body1">
//             <strong>Email:</strong> {modalData.email}
//           </Typography>
//           <Typography variant="body1">
//             <strong>Password:</strong> {modalData.password}
//           </Typography>
//           <Typography variant="body1">
//             <strong>Portal:</strong>{" "}
//             <a href={modalData.portal} target="_blank" rel="noopener noreferrer">
//               {modalData.portal}
//             </a>
//           </Typography>
//           <Typography
//             variant="caption"
//             sx={{ mt: 2, display: "block", color: "green" }}
//           >
//             ✅ Details copied to clipboard
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenModal(false)} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={openSnackbar}
//         message={SnackbarMsg}
//         autoHideDuration={2000}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         onClose={() => setOpenSnackbar(false)}
//       />
//     </DashboardLayout>
//   );
// }

// export default UserList;


import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import dayjs from 'dayjs';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { FormControl, InputLabel, Select, MenuItem, Snackbar, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

function UserList() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteBox, setdeleteBox] = useState(false);
  const [deleteuserId, setdeleteuserId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Separate filter states
  const [createdByFilter, setCreatedByFilter] = useState("");
  const [updatedByFilter, setUpdatedByFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [lastLoginDate, setLastLoginDate] = useState("");

  const [creatorNames, setCreatorNames] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({ email: "", password: "", portal: "" });

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    mobileNumber: "",
    userRole: "",
    margin: "",
    password: "",
    updated_at: '',
    updated_by: '',
    createdByName: "",
    updatedByName: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");

  useEffect(() => {
    const BUSINESS_TEAM_check = localStorage.getItem("userRole");
    if (BUSINESS_TEAM_check === 'BUSINESS_TEAM') {
      fetchUsersBusiness();
    }
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.get("https://api.exampladmedia.com/auth/getAllUsers", {
        headers: {
          Authorization: sessionToken,
        },
      });

      const currentUserRole = localStorage.getItem("userRole");

      const userColumns = [
        { Header: "Sr. No.", accessor: "srNo", align: "center" },
        { Header: " Client Email", accessor: "email", align: "center" },
        { Header: "Client Name", accessor: "name", align: "center" },
        { Header: "Margin", accessor: "margin", align: "center" },
        { Header: "Created By", accessor: "createdByName", align: "center" },
        { Header: "Created At", accessor: "created_at", align: "center" },
        { Header: "Updated By", accessor: "updatedByName", align: "center" },
        // { Header: "Updated By", accessor: "updated_by", align: "center" },
        { Header: "Updated At", accessor: "updated_at", align: "center" },
        { Header: "Last Login ", accessor: "lastLogin", align: "center" },
        {
          Header: "User Role",
          accessor: (row) => (row.userRole === "ADMIN" ? "OPERATIONS" : row.userRole),
          align: "center",
        },
        {
          Header: "Actions",
          accessor: "actions",
          align: "center",
        },
      ];

      const userRows = response.data
        .filter((user) => user.userRole !== "SUPER_ADMIN")
        .map((user, index) => ({
          srNo: index + 1,
          email: user.email,
          name: user.name,
          margin: user.margin || "-",
          created_by: user.created_by || "-",
          created_at: user.created_at ? dayjs(user.created_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
          createdByName: user.createdByName || "exampladpricing",
          updated_by: user.updated_by || "-",
          updated_at: user.updated_at ? dayjs(user.updated_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
          updatedByName: user.updatedByName || "exampladpricing",
          lastLogin: user.lastLogin ? dayjs(user.lastLogin).format("DD-MMM-YYYY HH:mm:ss") : "-",
          lastLoginRaw: user.lastLogin, // Added for correct sorting
          userRole: user.userRole,
          actions: (
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <EditIcon
                style={{
                  color: "green",
                  cursor: "pointer",
                  display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                }}
                onClick={() => handleEdit(user)}
              />
              <DeleteIcon
                style={{
                  color: "red",
                  cursor: "pointer",
                  display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                }}
                onClick={() => handleConfirmDelete(user.userId)}
              />
            </div>
          ),
        }));

      setColumns(userColumns);
      setRows(userRows);

      const allNames = [
        ...new Set([
          ...response.data.map((user) => user.createdByName).filter(Boolean),
          ...response.data.map((user) => user.updatedByName).filter(Boolean),
        ]),
      ];
      setCreatorNames(allNames);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsersBusiness = async () => {
    setLoading(true);
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const ueserId = localStorage.getItem("ueserId");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.get(`https://api.exampladmedia.com/auth/getUsers/${ueserId}`, {
        headers: {
          Authorization: sessionToken,
        },
      });

      const currentUserRole = localStorage.getItem("userRole");

      const userColumns = [
        { Header: "Sr. No.", accessor: "srNo", align: "center" },
        { Header: "Email", accessor: "email", align: "center" },
        { Header: "Name", accessor: "name", align: "center" },
        { Header: "Margin", accessor: "margin", align: "center" },
        ...(currentUserRole === "SUPER_ADMIN"
          ? [
            { Header: "Created By", accessor: "createdByName", align: "center" },
          ]
          : []),
        { Header: "Created At", accessor: "created_at", align: "center" },
        { Header: "Created By Name", accessor: "createdByName", align: "center" },
        ...(currentUserRole === "SUPER_ADMIN"
          ? [
            { Header: "Updated By", accessor: "updated_by", align: "center" },
          ]
          : []),
        { Header: "Updated At", accessor: "updated_at", align: "center" },
        { Header: "Updated By Name", accessor: "updatedByName", align: "center" },
        { Header: "Last Login ", accessor: "lastLogin", align: "center" },
        { Header: "User Role", accessor: "userRole", align: "center" },
        {
          Header: "Actions",
          accessor: "actions",
          align: "center",
        },
      ];

      const userRows = response.data
        .filter((user) => user.userRole !== "SUPER_ADMIN")
        .map((user, index) => ({
          srNo: index + 1,
          email: user.email,
          name: user.name,
          margin: user.margin || "-",
          created_by: user.created_by || "-",
          created_at: user.created_at ? dayjs(user.created_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
          createdByName: user.createdByName || "exampladpricing",
          updated_by: user.updated_by || "-",
          updated_at: user.updated_at ? dayjs(user.updated_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
          updatedByName: user.updatedByName || "exampladpricing",
          lastLogin: user.lastLogin ? dayjs(user.lastLogin).format("DD-MMM-YYYY HH:mm:ss") : "-",
          lastLoginRaw: user.lastLogin, // Added for correct sorting
          userRole: user.userRole,
          actions: (
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <EditIcon
                style={{
                  color: "green",
                  cursor: "pointer",
                  display: currentUserRole === "SUPER_ADMIN" || currentUserRole === "BUSINESS_TEAM" ? "inline-block" : "none",
                }}
                onClick={() => handleEdit(user)}
              />
              <DeleteIcon
                style={{
                  color: "red",
                  cursor: "pointer",
                  display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                }}
                onClick={() => handleConfirmDelete(user.userId)}
              />
            </div>
          ),
        }));

      setColumns(userColumns);
      setRows(userRows);

      const allNames = [
        ...new Set([
          ...response.data.map((user) => user.createdByName).filter(Boolean),
          ...response.data.map((user) => user.updatedByName).filter(Boolean),
        ]),
      ];
      setCreatorNames(allNames);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setFormData({
      email: user.email,
      margin: user.margin,
      userRole: user.userRole,
      password: user.password,
      updated_at: new Date().toISOString(),
      updatedByName: localStorage.getItem("name"),
      updated_by: localStorage.getItem("userRole"),
    });
    setOpen(true);
  };

  const handleConfirmDelete = (userId) => {
    setdeleteuserId(userId);
    setdeleteBox(true);
  };

  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.delete(`https://api.exampladmedia.com/auth/delete/${deleteuserId}`, {
        headers: {
          Authorization: sessionToken,
        },
      });

      if (response.status === 200) {
        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        setdeleteBox(false);
        fetchUsers();
      }
    } catch (error) {
      if (error.response) {
        setSnackbarMsg(error.response.data.message || "An error occurred.");
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };

  const handleSave = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.put(
        `https://api.exampladmedia.com/auth/edit/${selectedUser.userId}`,
        { ...formData },
        { headers: { Authorization: sessionToken } }
      );

      const portalLink = "https://pricing.exampladmedia.com";
      const clipboardText = `Email: ${formData.email}\nPassword: ${formData.password}\nPortal: ${portalLink}`;

      if (response.status === 200) {
        setModalData({
          email: formData.email,
          password: formData.password,
          portal: portalLink,
        });
        setOpenModal(true);

        try {
          await navigator.clipboard.writeText(clipboardText);
        } catch {
          const textarea = document.createElement("textarea");
          textarea.value = clipboardText;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }

        setSnackbarMsg(response.data.message || "User updated and details copied!");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        setOpen(false);
        fetchUsers();
      }
    } catch (error) {
      setSnackbarMsg(error.response?.data?.message || "An error occurred.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };

  const handleDownloadExcel = () => {
    const exportData = filteredRows.map((row) => {
      const { actions, lastLoginRaw, ...rest } = row; // Exclude lastLoginRaw from excel download
      return rest;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "UserList.xlsx");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteCancel = () => {
    setdeleteBox(false);
  };

  const currentUserRole = localStorage.getItem("userRole");

  const filteredRows = rows.filter((row) => {
    const matchesSearch =
      (row.name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (row.email?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (row.createdByName?.toLowerCase() || "").includes(searchTerm.toLowerCase());

    const matchesCreatedBy =
      createdByFilter === ""
        ? true
        : (row.createdByName?.toLowerCase() || "") === createdByFilter.toLowerCase();

    const matchesUpdatedBy =
      updatedByFilter === ""
        ? true
        : (row.updatedByName?.toLowerCase() || "") === updatedByFilter.toLowerCase();

    const createdAt = row.created_at !== "-" ? dayjs(row.created_at) : null;
    const matchesCreatedDate = fromDate
      ? createdAt &&
      createdAt.isAfter(dayjs(fromDate).startOf('day').subtract(1, 'ms')) &&
      createdAt.isBefore(dayjs(fromDate).endOf('day').add(1, 'ms'))
      : true;

    const lastLogin = row.lastLogin !== "-" ? dayjs(row.lastLogin) : null;
    const matchesLastLogin = lastLoginDate
      ? lastLogin &&
      lastLogin.isAfter(dayjs(lastLoginDate).startOf('day').subtract(1, 'ms')) &&
      lastLogin.isBefore(dayjs(lastLoginDate).endOf('day').add(1, 'ms'))
      : true;

    return matchesSearch && matchesCreatedBy && matchesUpdatedBy && matchesCreatedDate && matchesLastLogin;
  }).sort((a, b) => {
    // Sort logic to bring the latest last login to the top
    const dateA = a.lastLoginRaw ? dayjs(a.lastLoginRaw).valueOf() : 0;
    const dateB = b.lastLoginRaw ? dayjs(b.lastLoginRaw).valueOf() : 0;
    
    return dateB - dateA;
  });

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={2}
              >
                <h2 style={{ color: "white", margin: 0 }}>User List</h2>

                <MDBox display="flex" flexWrap="wrap" gap={2} alignItems="center">
                  {currentUserRole === "SUPER_ADMIN" && (
                    <>
                      <MDBox sx={{ background: "white", borderRadius: "8px" }}>
                        <FormControl
                          variant="outlined"
                          sx={{
                            width: 220,
                            backgroundColor: "white",
                            borderRadius: "8px",
                            boxShadow: 1,
                            '& .MuiOutlinedInput-root': {
                              height: 48,
                              borderRadius: '8px',
                              backgroundColor: 'white',
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: '14px',
                              top: '-4px',
                              backgroundColor: 'white',
                              padding: '0 4px',
                            },
                            '& .MuiSelect-select': {
                              padding: '14px',
                              fontSize: '14px',
                            },
                          }}
                        >
                          <InputLabel>Created By</InputLabel>
                          <Select
                            value={createdByFilter}
                            onChange={(e) => setCreatedByFilter(e.target.value)}
                            label="Created By"
                          >
                            <MenuItem value="">All</MenuItem>
                            {creatorNames.map((name) => (
                              <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </MDBox>

                      <MDBox sx={{ background: "white", borderRadius: "8px" }}>
                        <FormControl
                          variant="outlined"
                          sx={{
                            width: 220,
                            backgroundColor: "white",
                            borderRadius: "8px",
                            boxShadow: 1,
                            '& .MuiOutlinedInput-root': {
                              height: 48,
                              borderRadius: '8px',
                              backgroundColor: 'white',
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: '14px',
                              top: '-4px',
                              backgroundColor: 'white',
                              padding: '0 4px',
                            },
                            '& .MuiSelect-select': {
                              padding: '14px',
                              fontSize: '14px',
                            },
                          }}
                        >
                          <InputLabel>Updated By</InputLabel>
                          <Select
                            value={updatedByFilter}
                            onChange={(e) => setUpdatedByFilter(e.target.value)}
                            label="Updated By"
                          >
                            <MenuItem value="">All</MenuItem>
                            {creatorNames.map((name) => (
                              <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </MDBox>

                      <TextField
                        type="date"
                        label="Created At"
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            color: "#000",     // black
                            fontWeight: 700,   // bold
                            fontSize: "13px",
                          },
                        }}
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "4px",
                          width: "200px",

                          "& .MuiInputLabel-root": {
                            color: "#000",
                            fontWeight: 700,
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#000",
                            fontWeight: 700,
                          },
                        }}
                      />


                      <TextField
                        type="date"
                        label="Last Login"
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            color: "#000",     // black
                            fontWeight: 700,   // bold
                            fontSize: "13px",
                          },
                        }}
                        value={lastLoginDate}
                        onChange={(e) => setLastLoginDate(e.target.value)}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "4px",
                          width: "200px",

                          "& .MuiInputLabel-root": {
                            color: "#000",
                            fontWeight: 700,
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#000",
                            fontWeight: 700,
                          },
                        }}
                      />

                    </>
                  )}

                  <TextField
                    variant="outlined"
                    placeholder="Search by name, email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ backgroundColor: "white", borderRadius: "4px", width: "400px" }}
                  />

                  {currentUserRole === "SUPER_ADMIN" && (
                    <Tooltip title="Download User List">
                      <Button
                        variant="outlined"
                        onClick={handleDownloadExcel}
                        style={{
                          backgroundColor: "white",
                          color: "grey",
                          border: "1px solid #49a3f1",
                          height: "48px",
                        }}
                      >
                        <DownloadIcon />
                      </Button>
                    </Tooltip>
                  )}
                </MDBox>
              </MDBox>

              <MDBox pt={3}>
                {loading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                  >
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows: filteredRows }}
                    isSorted={false}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit User</DialogTitle>
        <DialogContent>
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {formData.userRole === "BUSINESS_TEAM" || formData.userRole === "ADMIN" || (
            <TextField
              label="Margin"
              name="margin"
              value={formData.margin}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          )}
          <TextField
            label="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} style={{ color: "green" }}>
            Save
          </Button>
          <Button onClick={handleClose} style={{ color: "red" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this user?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} style={{ color: "green" }}>
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel} style={{ color: "red" }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>User Updated</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">
            <strong>Email:</strong> {modalData.email}
          </Typography>
          <Typography variant="body1">
            <strong>Password:</strong> {modalData.password}
          </Typography>
          <Typography variant="body1">
            <strong>Portal:</strong>{" "}
            <a href={modalData.portal} target="_blank" rel="noopener noreferrer">
              {modalData.portal}
            </a>
          </Typography>
          <Typography
            variant="caption"
            sx={{ mt: 2, display: "block", color: "green" }}
          >
            ✅ Details copied to clipboard
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        message={SnackbarMsg}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenSnackbar(false)}
      />
    </DashboardLayout>
  );
}

export default UserList;